import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { DropdownWithSearch, Dropdown } from "hesus-ui-kit";

import {
  FILTER_TYPE_DROPDOWN,
  FILTER_TYPE_MULTI_SELECT_DROPDOWN,
} from "@utils/constants";

const CustomColumnFilter = ({
  column: { filterValue, setFilter },
  options,
  label,
  name,
  labelClass,
  containerClass,
  inputClass,
  defaultOption,
  placeholder,
  type,
}) => {
  useEffect(() => {
    if (
      defaultOption?.length > 0 &&
      type === FILTER_TYPE_MULTI_SELECT_DROPDOWN
    ) {
      setFilter(defaultOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {type === FILTER_TYPE_DROPDOWN && (
        <Dropdown
          label={label}
          name={name}
          labelClass={labelClass}
          placeholder={placeholder}
          containerClass={containerClass}
          inputClass={inputClass}
          // value={
          //   filterValue || defaultOption
          //     ? options.find((option) => option.label === defaultOption)
          //         ?.value ?? ""
          //     : ""
          // }
          value={filterValue || defaultOption}
          defaultOption={defaultOption}
          options={options}
          onChange={(e) => {
            setFilter(e.value);
          }}
        />
      )}
      {type === FILTER_TYPE_MULTI_SELECT_DROPDOWN && (
        <DropdownWithSearch
          label={label}
          name={name}
          labelClass={labelClass}
          placeholder={placeholder}
          containerClass={containerClass}
          value={filterValue || defaultOption}
          defaultOption={defaultOption}
          options={options}
          onChange={(e) => {
            setFilter(e);
          }}
        />
      )}
    </>
  );
};

CustomColumnFilter.propTypes = {
  type: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  labelClass: PropTypes.string.isRequired,
  containerClass: PropTypes.string.isRequired,
  inputClass: PropTypes.string.isRequired,
  defaultOption: PropTypes.oneOfType([
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string }),
    PropTypes.arrayOf({ label: PropTypes.string, value: PropTypes.string }),
  ]),
  name: PropTypes.string.isRequired,
  column: PropTypes.shape({
    filterValue: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        })
      ),
    ]),
    setFilter: PropTypes.func.isRequired,
  }),
};

CustomColumnFilter.defaultProps = {
  column: {
    filterValue: "",
  },
  defaultOption: null,
  placeholder: "",
};

export default CustomColumnFilter;
